<template>
  <div>
    <h1 id="jump-to-header">{{heading || "View"}}</h1>
    <poly-integer-reference-show :id="id" :api_path="api_path"></poly-integer-reference-show>
  </div>
</template>

<script>
import PolyIntegerReferenceShow from './PolyIntegerReferenceShow.vue'

export default {
  components: {
    PolyIntegerReferenceShow
  },
  props: {
    id: String,
    heading: {
      Type: String
    },
    api_path: {
      Type: String
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>
